import React, { Component } from 'react';
import { connect } from 'dva';
import { Button, Popover, Row, Col } from 'antd';
import Dimio, { DimioComponent } from 'dimio';
import ListPage from '../../travel/components/ListPage';
import _ from 'lodash';

import config from '../../travel/config/config';
import "../style/search.scss";
import "../../travel/style/travel.scss";
const { travel } = config;

class SearchByCity extends DimioComponent {

  render() {
    const { items, onClick } = this.props;

    const cityList = (
      <div className='container select-city__container'>
        <div className='select-city position-relative'>
          {/* <Button type='circle' icon='close' onClick={this.onFocus} className='position-absolute' /> */}
          <div className='select-city__title'>都市から探す</div>
          <Row gutter={16}>
            {items.map(opt => (
              <Col
                key={opt.key} xs={12} sm={8}
              //                onClick={e => this.onSelect(e, opt)}
              >
                <a className='select-city__item' href='#' onClick={e => onClick(e, opt)}>
                  {opt.name} <span>({opt.cnt})</span>
                </a>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );

    return (
      <Popover
        content={cityList}
        placement="bottom"
        className='travel-search-city'
        /*
        ref={ref => {
          this.suggest = ref
        }}
        */
        trigger="click">
        <Button className='ant-btn ant-input-search-button ant-btn-primary travel-search-city-btn'>都市から探す</Button>
      </Popover>
    )
  }
}

export default connect(({ core, search }) => ({
  core, search
}))(SearchByCity);



// WEBPACK FOOTER //
// ./src/pages/search/components/SearchByCity.js